import React, { lazy, Suspense } from 'react';
import ErrorBoundary from 'components/error-boundary/ErrorBoundary';

// Lazy boundary: TestimonialAnimation pulls in react-slick / slick-carousel
// (~105KB). It is imported eagerly by NavBar and LayoutContainer but only
// rendered on the market-scan waiting screen, so loading it through
// React.lazy keeps react-slick out of the initial bundle. The component
// takes no props, so call sites need no change.
//
// Pure decoration: if the chunk fails to load, render nothing rather than
// forcing a page reload (an ErrorBoundary with a null fallback, not
// lazyWithRetry).
const TestimonialAnimationImpl = lazy(() => import('./TestimonialAnimationImpl'));

const TestimonialAnimation = () => (
  <ErrorBoundary fallback={null}>
    <Suspense fallback={null}>
      <TestimonialAnimationImpl />
    </Suspense>
  </ErrorBoundary>
);

export default TestimonialAnimation;
